import React from "react";
import { NOOP } from "@fedsim/helpers";
import { Box } from "@mui/material";
import { BORDERRADIUS as borderRadius } from "@fedsim/constants";

const defaultMaxWidth = 125;

const sx = {
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius,
  margin: "5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&:hover": {
    transform: "scale(1.09)",
    transition: "transform 0.3s ease-in-out",
    backgroundColor: "rgba(50, 50, 50, 0.5)",
  },
};

export function AddTileView(props): JSX.Element {
  const { maxWidth = defaultMaxWidth, name, onClick } = props;

  return (
    <Box
      onClick={onClick}
      sx={{
        ...sx,
        display: "flex",
        flexDirection: "column",
        maxWidth,
        textAlign: 'center',
        alignItems: "center",
        justifyContent: "center",
        wordWrap: "break-word",
        height: maxWidth,
        color: "black",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
      }}
    >
      Choose <span>{name}</span>
    </Box>
  );
}

export function RemoveTileView(props): JSX.Element {
  const { maxWidth = defaultMaxWidth, name, onClick } = props;

  return (
    <Box
      onClick={onClick}
      sx={{
        ...sx,
        flexDirection: "column",
        maxWidth,
        alignItems: "center",
        justifyContent: "center",
        height: maxWidth,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
      }}
    >
      <>Remove {name}</>
    </Box>
  );
}

export function FlatTile(props): JSX.Element {
  const { maxWidth = defaultMaxWidth, onClick = NOOP, ...item } = props;
  const clickHandler = () => onClick(item);
  const { color, backgroundColor } = item

  return (
    <Box
      onClick={clickHandler}
      sx={{
        ...sx,
        color, backgroundColor,
        height: maxWidth,
        fontSize: 9,
        textAlign: 'center',
        maxWidth,
        backgroundImage: `url(${item?.image})`
      }}
    >{!item?.image ? item?.name : ''}</Box>
  );
}
